import { render, staticRenderFns } from "./putawayConfirm.vue?vue&type=template&id=4bfaa526&scoped=true&"
import script from "./putawayConfirm.vue?vue&type=script&lang=js&"
export * from "./putawayConfirm.vue?vue&type=script&lang=js&"
import style0 from "./putawayConfirm.vue?vue&type=style&index=0&id=4bfaa526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfaa526",
  null
  
)

export default component.exports